export const PROD_HOSTNAME = 'app.blueshift.fi';
